import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('po/purchase-order/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/purchase-order/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('po/exports/purchase-order/receivings', { params })
  },

  async show (id) {
    return axios.get(`po/purchase-order/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/purchase-order/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/purchase-order/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/purchase-order/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
